import isURL from 'validator/lib/isURL';

export default function validateUrl(url) {
  let message = '';
  let success = false;
  const options = {
    protocols: ['http', 'https'],
    require_protocol: true, // eslint-disable-line camelcase
  };

  if (!url.startsWith('http') && !url.startsWith('https')) {
    message = 'http 또는 https로 시작하는 주소를 입력해 주세요.';
  } else if (!isURL(url, options)) {
    message = '주소를 확인 후 다시 입력해 주세요.';
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}
